import { SYSTEM_APP_IDS } from '@paperair/shared-types'
import { apiClient } from './client'

// Re-export shared utilities
export { getErrorMessage } from './client'

// Types for API responses
export interface UserProfile {
  userId: string
  email: string
  profile: {
    firstName?: string
    lastName?: string
    displayName?: string
    organization?: string
    jobTitle?: string
  }
  role: string
  scopes: {
    studioFilter: string[] | null
    formatPartnerFilter: string[] | null
    countryFilter: string[] | null
    exhibitorAssociations: string[] | null
  }
  appId?: string
}

export interface LoginResponse {
  accessToken: string
  refreshToken: string
  expiresIn: number
  user: UserProfile
  mustChangePassword?: boolean
}


/**
 * Login with email and password
 */
export async function login(email: string, password: string): Promise<LoginResponse> {
  const response = await apiClient.post<LoginResponse>('/auth/login', {
    email,
    password,
    appId: SYSTEM_APP_IDS.AUTH_ADMIN,
  })
  return response.data
}

/**
 * Refresh access token
 */
export async function refreshToken(token: string): Promise<LoginResponse> {
  const response = await apiClient.post<LoginResponse>('/auth/refresh', {
    refreshToken: token,
    appId: SYSTEM_APP_IDS.AUTH_ADMIN,
  })
  return response.data
}

/**
 * Logout current session
 * Token is automatically attached via request interceptor
 */
export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout')
}
